<template>
  <div v-if="errors">
    <div
      v-for="(v, k) in errors"
      :key="k"
    >
      <p
        v-for="error in v"
        :key="error"
      >
        {{ error }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Object,
      default: null,
    },
  },
};
</script>
